import React, { createContext, ReactNode, useEffect, useMemo, useState } from "react";
import { NotificationEmail } from "../../domain/user/notification/NotificationEmail";
import { useNotificationEmailList } from "../hooks/user/useNotificationEmailList";

type ContextType = {
    notificationEmailList: NotificationEmail[]
    setNotificationEmailList: React.Dispatch<React.SetStateAction<NotificationEmail[]>>
};

const defaultContextValue: ContextType = {
    notificationEmailList: [],
    setNotificationEmailList: () => {}
};

export const NotificationEmailContext = createContext(defaultContextValue);

export const NotificationEmailProvider = React.memo(function NotificationEmailProvider(props: Props) {
    const notifications = useNotificationEmailList();

    const [notificationEmailList, setNotificationEmailList] = useState<NotificationEmail[]>([]);

    const value: ContextType = useMemo(() => ({
        notificationEmailList: notificationEmailList,
        setNotificationEmailList: setNotificationEmailList,
    }), [notificationEmailList]);

    useEffect(() => {
        if (notifications) {
            setNotificationEmailList(notifications);
        }
    }, [notifications]);

    return (
        <NotificationEmailContext.Provider value={value}>
            {props.children}
        </NotificationEmailContext.Provider>
    );
});

type Props = {
    children: ReactNode
};
